/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      component (product-list filter control: forwards setReload)
 *   extends:   Component (@glimmer/component)
 *   template:  list-filters.hbs
 *   args:      @setReload
 *   uses:      -
 *   siblings:  -
 *   tests:     list-filters-test.js, list-filters-writes-test.js,
 *              storefront-components-test.js
 *   gotchas:   `{{on}}` appends the DOM Event as the last positional arg —
 *              setReload strips it from the optional `variable1`/`type`
 *              params via `instanceof Event` checks before forwarding
 *              (event-into-param class).
 *
 * Forwards filter changes to the host's @setReload, guarding the optional
 * positional params against an accidentally-appended DOM Event.
 */
import Component from '@glimmer/component';

import { action } from '@ember/object';

export default class ListFiltersComponent extends Component {
  @action
  setReload(variable, value, variable1 = null, value1 = null, type = null) {
    // {{on}} appends the DOM event as last arg; keep optional params clean
    if (variable1 instanceof Event) {
      variable1 = null;
    }
    if (type instanceof Event) {
      type = null;
    }

    this.args.setReload(variable, value, variable1, value1, type);
  }
}
